import { gql } from '@apollo/client';

const TAG_LIST_FIELDS = `
    _id
    tags {
        key
        label
        color
    }
`;

export const CREATE_CRM_TAG = gql`
    mutation CreateCrmTag($input: CreateCrmTagInput!) {
        createCrmTag(input: $input) {
            ${TAG_LIST_FIELDS}
        }
    }
`;

export const RENAME_CRM_TAG = gql`
    mutation RenameCrmTag($input: RenameCrmTagInput!) {
        renameCrmTag(input: $input) {
            ${TAG_LIST_FIELDS}
        }
    }
`;

export const DELETE_CRM_TAG = gql`
    mutation DeleteCrmTag($input: DeleteCrmTagInput!) {
        deleteCrmTag(input: $input) {
            ${TAG_LIST_FIELDS}
        }
    }
`;
